import { GetterTree } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IContactState from './types/IContactState';

const getters: GetterTree<IContactState, IRootState> = {};

export default getters;
